'use strict';

module.exports = require('react/lib/ReactDOM');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dom/index.js
 ** module id = 110
 ** module chunks = 0 1 2 3 4 5 6 7
 **/